import React from 'react'

export default React.createClass({

  render: function() {
    let arrowRight = '/common/latest/images/consumer/gray-arrow.png'
    let show = [];
    let answers = [];
    if(!this.props.full){
      let imgStyles = {
        maxWidth: '1.5em',
        maxHeight: '1.5em',
        paddingRight: '5px'
      }
      let arrowStyles = {
        ...imgStyles,
        marginTop: '5px'
      }
      for (let i = 0; i < this.props.data.length; i++) {
        if(i === 0){
          show.push(
          <div key={i}>
            <a onClick={() => this.props.showAnswers(this.props.data[i])}>{this.props.data[i].label}</a>
            <img className='img-responsive pull-right' alt='>' style={arrowStyles} src={arrowRight} />
          </div>)
        }else{
        show.push(
          <div key={i}>
            <hr style={{borderColor: '#b9b9b9', marginBottom: 20}}/>
            <div style={{width: '90%'}}>
              <a onClick={() => this.props.showAnswers(this.props.data[i])}>{this.props.data[i].label}</a>
            </div>
            <img className='img-responsive pull-right' alt='>' style={{position: 'relative', top: -15, paddingRight: 5}} src={arrowRight} />
          </div>)
        }
      }
    }
    else{
       for (let i = 0; i < this.props.data.length; i++) {
          answers.push(<div key={i} id={i} style={{marginTop: 20}}>
            <h4 style={{fontSize: '2rem'}}>{this.props.data[i].label}</h4>
            <p>{this.props.data[i].question}</p>
            <h6 className='small' style={{position: 'relative',top: -10, textAlign: 'right'}}> <a href={'#top'}>back to top</a></h6>
          </div>)

          show.push(<div key={i} style={{marginBottom: 10, textDecoration: 'underline'}}>
            <a href={'#' + i}>{this.props.data[i].label}</a>
          </div>)
       }
    }

    return (
      <div className='col-xs-12' >
        <div>{show}</div>
        <div>{answers}</div>
      </div>
    )}
  })



// WEBPACK FOOTER //
// ./src/components/support/questions.jsx